import type { UpdatePaymentRequest } from '../../../generated-types';
import nullableZonedDateToUtc from '../../../utils/mapper/nullableZonedDateToUtc';
import { EfakturaState } from '../../transaction/EFaktura/form/state';

export default (efakturaState: EfakturaState): UpdatePaymentRequest => ({
    paymentType: 'EFAKTURA',
    amount: efakturaState.amount || 0,
    currency: 'NOK',
    fromAccountNumber: efakturaState.fromAccount!,
    paymentDate: nullableZonedDateToUtc(efakturaState.paymentDate)!,
    toAccount: efakturaState.toAccount!.accountNumber,
    text: efakturaState.note,
    kid: efakturaState.kid,
    efakturaId: efakturaState.efakturaId,
});
